import { PubTournament } from "../../../../../../../api/types";
import {
  getLevelText,
  getCurrentBlindTitle,
  getBlindValue,
  getPlayersText,
} from "../../../../../../../utils/tournament";
import PremiumPubTournamentTimer from "../../../../../PremiumPub/components/tournaments/components/tournament-timer";
import {
  FestivalBannerTournamentBlind,
  FestivalBannerTournamentBlindWrapper,
  FestivalBannerTournamentInfoTop,
  FestivalBannerTournamentInfoWrapper,
  FestivalBannerTournamentWrapper,
} from "./style";

interface RabbitFestivalBannerTournamentProps {
  tournament: PubTournament;
}

const FestivalBannerTournament = ({
  tournament,
}: RabbitFestivalBannerTournamentProps) => {
  return (
    <FestivalBannerTournamentWrapper>
      <div className="timer">
        <PremiumPubTournamentTimer
          timer={tournament.timeInfo}
          width={73}
          radius={36.5}
        />
      </div>
      <FestivalBannerTournamentInfoWrapper>
        <FestivalBannerTournamentInfoTop>
          <div className="level">{getLevelText(tournament)}</div>
          <div className="player">
            PLAYERS <span>{getPlayersText(tournament)}</span>
          </div>
        </FestivalBannerTournamentInfoTop>
        <FestivalBannerTournamentBlindWrapper>
          <FestivalBannerTournamentBlind isNext={false}>
            <div className="name">{getCurrentBlindTitle(tournament)}</div>
            <div className="value">{getBlindValue(tournament, "current")}</div>
          </FestivalBannerTournamentBlind>
          <FestivalBannerTournamentBlind isNext={true}>
            <div className="name">다음 BLINDS</div>
            <div className="value">{getBlindValue(tournament, "next")}</div>
          </FestivalBannerTournamentBlind>
        </FestivalBannerTournamentBlindWrapper>
      </FestivalBannerTournamentInfoWrapper>
    </FestivalBannerTournamentWrapper>
  );
};

export default FestivalBannerTournament;
